import { findIdSelector } from "../../pages/apps/Assisted/forms/create/reduxSelector";
import { store } from "../../stateManager";
import { getRandomId } from "../../utils/random-id";

interface ISectionalOptions {
  isDynamic?: boolean;
  bindPrefix?: string;
}

// When a component gets dragged into a new container, this generates new ID for it
export const generateId = (item: any, container: any) => {
  const idArray =
    container.json.fields.length > 0 &&
    container.json.fields.map((field: any) => {
      return parseInt(field.id.split("-")[field.id.split("-").length - 1]);
    });
  const incrementedId = idArray.length > 0 ? Math.max(...idArray) + 1 : 0;
  const generatedId = `${container.json.id
    }#${item.json.type.toLowerCase()}-${incrementedId}`;

  return generatedId;
};

// When a section gets dragged into a new container, this generates new Ids for all components inside the section
export const generateSectionalIds = (
  container: any,
  newContainerId: any,
  options?: ISectionalOptions
) => {
  const containerCopy = JSON.parse(JSON.stringify(container.json));

  containerCopy.id = newContainerId;
  if (containerCopy.fields) {
    containerCopy.fields = containerCopy.fields.map((item: any) => {
      // to get the last number from an id, we split it with hyphen and take the last item
      const hyphenSplit = item.id.split("-");
      const newIdNumber = hyphenSplit[hyphenSplit.length - 1];
      const newId = `${newContainerId}#${item.type.toLowerCase()}-${newIdNumber}`;

      if (
        item.label.toLowerCase() === "section" ||
        item.label.toLowerCase() === "container"
      ) {
        return {
          ...generateSectionalIds({ json: item }, newId, options),
          id: newId,
          bind: options && options.bindPrefix && item.bind ? `${options.bindPrefix}_${item.bind}` : item.bind,
          elementId:
            options && options.isDynamic ? getRandomId() : item.elementId,
          componentId: item.componentId || getRandomId(),
        };
      } else {
        return {
          ...item,
          id: newId,
          bind: options && options.bindPrefix && item.bind ? `${options.bindPrefix}_${item.bind}` : item.bind,
          elementId:
            options && options.isDynamic ? getRandomId() : item.elementId,
          componentId: item.componentId || getRandomId(),
        };
      }
    });
  }

  return containerCopy;
};

export const getCardContainer = (selectedItemId: string, formId: string) => {
  const state = store.getState();
  const cardIdSplit = selectedItemId.split("#");
  cardIdSplit.pop();
  const val = findIdSelector(state, formId, cardIdSplit, true);
  return val;
};
